import { apiService } from "@/_services";
import { timeParseNull2 } from "@/_core/_helpers/_helpers";

/**
 * Processes and retrieves historical data for relative values.
 * This function fetches data using the provided query parameters and parses it into a usable format.
 * @param {object} ctx - Context variables containing the state for loading and data storage.
 * @param {object} params - Query parameters used for fetching historical data.
 * @returns {Promise} - Resolves when the data is successfully processed and stored in the context.
 */
export function processHistorical(ctx, params) {
  // Call the API service to fetch historical data based on the provided params
  return apiService
    .getAll(params) // Fetch data using GET request
    .then(data => {
      // Make a deep copy of the fetched data (to prevent any unwanted mutations)
      data = JSON.parse(JSON.stringify(data));
      // Store column names from the first data entry (assumed to be consistent across the dataset)
      ctx.columns = Object.keys(data[0]);
      // Iterate over each data entry and parse the 'date' field into a Date object
      data.forEach(function(d) {
        d.date = timeParseNull2(d.date); // Parse date string into JavaScript Date object
      });
      // Store the processed data in the context's histData field
      ctx.histData = data;
      // Hide the loading spinner after data is successfully processed
      ctx.showLoadingHistory = false;
    })
    .catch(function(error) {
      // In case of an error, log it and stop showing the loading spinner
      ctx.showLoadingHistory = false;
      console.log(error);
    });
}
